import React from 'react';
import { createRoot } from 'react-dom/client';
import { Login } from '~/components/Login';
import { PdfEditor } from '~/components/PdfEditor';
import {
  GlobalStateProvider,
  useGlobalState,
} from '~/context/GlobalStateContext';

const App: React.FC = () => {
  const { generalState } = useGlobalState();

  if (!generalState.user && !generalState.loading) return <Login />;

  if (generalState.loading)
    return (
      <div className='flex justify-center items-center w-screen h-screen'>
        Loading...
      </div>
    );

  return <PdfEditor />;
};

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <GlobalStateProvider>
    <App />
  </GlobalStateProvider>,
);
